import React from 'react'

interface SpinnerProps {
  size?: 'small' | 'normal' | 'large'
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'normal' }) => {
  const sizes = { small: '16px', normal: '24px', large: '32px' }
  const dim = sizes[size]

  return (
    <div
      style={{
        width: dim,
        height: dim,
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #0972d3',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    >
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
